import * as React from 'react';
import {Box, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';

const columns = [
    {
      icon: <img src="./hospitalityIcon.png" alt='hospitalityIcon' />, // Example icon, replace with appropriate ones
      title: 'Hospitality',
      //description: 'Quick and easy to install with zero impact to day-to-day running of your business and customers.'
      description: 'Seamlessly integrated with no disruption to daily operations — delivering powerful insights that enhance safety, compliance, and guest experience.'
    },
    {
      icon: <img src="./facilitiesIcon.png" alt='facilitiesIcon' />, // Example icon, replace with appropriate ones
      title: 'Facilities Management',
      //description: 'Monitor assets remotely. Generate relevant reports to act on problems quickly and efficiently.'
      description: 'Monitor critical assets remotely, generate actionable reports, and respond to issues with speed and precision.'
    },
    {
      icon: <img src="./waterAssociationsIcon.png" alt='waterAssociationsIcon' />, // Example icon, replace with appropriate ones
      title: 'Water Associations',
      //description: 'Scalable hardware solution to suit you and your customers\' needs. Start small and expand as you wish.'
      description: 'A scalable, flexible solution tailored to your operational needs—start with a few sensors and expand as your network grows.'
    }
];

const WhoIsSigmatiqaForSection = () => {
    return (
        <Box sx={{flexGrow: 1, padding: 2, justifyContent: "center", alignItems: 'center', marginBottom: 20 }}>
            <Box sx={{ textAlign: 'center', marginBottom: 4}}>
                <Typography 
                    variant="h4" 
                    sx={{ 
                        fontSize: 36, 
                        fontWeight: 600, // semi-bold
                        color: '#111111', 
                        marginBottom: 1
                    }}
                >
                    One Sensor. Endless Insights.
                </Typography>
                <Typography 
                    variant="subtitle1" 
                    sx={{ 
                        fontSize: 24, 
                        fontWeight: 'regular', 
                        color: '#4d4d4d' 
                    }}
                >
                    Who is Sigmatiqa suitable for?
                </Typography>
            </Box>
            <Grid 
                container 
                spacing={"127px"} 
                justifyContent="center" 
                alignItems="flex-start"
            >
                {columns.map((column, index) => (
                    <Grid 
                        xs={12} 
                        sm={6} 
                        md={4} 
                        key={index} 
                        sx={{ textAlign: 'center' }}
                    >
                        <Box sx={{width: "299px"}}>
                            <Box>{column.icon}</Box>
                            <Typography 
                                variant="h5" 
                                sx={{ 
                                    fontFamily: 'Roboto, Arial, sans-serif',
                                    fontSize: 28, 
                                    fontWeight: 'bold', 
                                    color: '#111111', 
                                    marginTop: 1
                                }}
                            >
                                {column.title}
                            </Typography>
                            <Typography 
                                variant="body1" 
                                sx={{ 
                                    fontFamily: 'Roboto, Arial, sans-serif',
                                    fontSize: 20, 
                                    fontWeight: 'regular', 
                                    color: '#4d4d4d', 
                                    marginTop: 1
                                }}
                            >
                                {column.description}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default WhoIsSigmatiqaForSection;